import { createContext, FC, ReactNode } from 'react';

export type ICreateBranchContext = {
  id?: string;
  onSucceed: () => void;
  onCancel: () => void;
};

const defaultValues: ICreateBranchContext = {
  onSucceed: () => {},
  onCancel: () => {},
};

export const CreateBranchContext = createContext<ICreateBranchContext>(defaultValues);

export const CreateBranchProvider: FC<Partial<ICreateBranchContext> & { children?: ReactNode }> = ({ children, id, onSucceed = defaultValues.onSucceed, onCancel = defaultValues.onCancel }) => {
  return <CreateBranchContext.Provider value={{ id, onSucceed, onCancel }}>{children}</CreateBranchContext.Provider>;
};
